import { render, staticRenderFns } from "./zhuanTiGuiNa.vue?vue&type=template&id=1c5f2c5b&scoped=true&"
import script from "./zhuanTiGuiNa.vue?vue&type=script&lang=js&"
export * from "./zhuanTiGuiNa.vue?vue&type=script&lang=js&"
import style0 from "./zhuanTiGuiNa.vue?vue&type=style&index=0&id=1c5f2c5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f2c5b",
  null
  
)

export default component.exports